import { render, staticRenderFns } from "./PayHand.vue?vue&type=template&id=31852ecb&scoped=true&"
import script from "./PayHand.vue?vue&type=script&lang=js&"
export * from "./PayHand.vue?vue&type=script&lang=js&"
import style0 from "./PayHand.vue?vue&type=style&index=0&id=31852ecb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31852ecb",
  null
  
)

export default component.exports